// MA19 합배송스케쥴 — moms-be `/api/v1/pair-order-schedules` (TM-4166). 1.0 `/api/grid/*` 는 부르지 않는다.
import request, { getExcel } from '@/utils/request'
import type {
  PairOrderScheduleDownloadReq,
  PairOrderScheduleDto,
  PairOrderScheduleSaveReq,
  PairOrderScheduleSaveRes,
  PairOrderScheduleSearchReq,
} from './types'

const BASE_PATH = '/api/v1/pair-order-schedules'

export const searchPairOrderSchedules = (params: PairOrderScheduleSearchReq) =>
  request.get<ApiResponseV2<{ items: PairOrderScheduleDto[] }>, PairOrderScheduleSearchReq>(BASE_PATH, params)

/** 신규·수정·삭제를 한 트랜잭션으로 반영한다. 삭제만 보낼 때는 creates·updates 를 비운다. */
export const savePairOrderSchedules = (body: PairOrderScheduleSaveReq) =>
  request.post<ApiResponseV2<PairOrderScheduleSaveRes>, PairOrderScheduleSaveReq>(`${BASE_PATH}/save`, body)

/** xlsx 다운로드. 서버가 감사로그에 사유를 남긴다. 실패 바디가 Blob 으로 오므로 JSON 으로 되돌려 사유를 꺼낼 수 있게 한다. */
export const downloadPairOrderSchedulesExcel = async (params: PairOrderScheduleDownloadReq): Promise<void> => {
  let res
  try {
    res = await getExcel(`${BASE_PATH}/excel`, { method: 'get', params })
  } catch (e) {
    const resp = (e as { response?: { data?: unknown } })?.response
    if (resp?.data instanceof Blob) {
      try {
        resp.data = JSON.parse(await resp.data.text())
      } catch {
        /* JSON 이 아니면 상태코드만 남긴다 */
      }
    }
    throw e
  }

  const a = document.createElement('a')
  a.href = URL.createObjectURL(res.data)
  a.download = parseFileName(String(res.headers?.['content-disposition'] ?? ''), '합배송스케쥴.xlsx')
  a.click()
  URL.revokeObjectURL(a.href)
}

const parseFileName = (disposition: string, fallback: string): string => {
  const utf8 = /filename\*=utf-8''([^;]+)/i.exec(disposition)
  if (utf8?.[1]) {
    try {
      return decodeURIComponent(utf8[1].trim())
    } catch {
      /* 디코딩 실패 시 폴백 */
    }
  }
  return fallback
}
